/**
 * Validates a value is an email.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name email
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null || value === '') {
    return Promise.resolve(null);
  }

  return Promise.resolve(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? null : 'not-email');
}

module.exports = validate;